import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { findUrlForMediaArray } from "../utils";
import { Store } from "../store";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Carousel({ block }) {
  const config = Store.useState(s => s.config);

  const transitionType = config.eshop.theme.selected?.settings?.carousel?.transitionType;
  const speed = config.eshop.theme.selected?.settings?.carousel?.transitionSpeed;
  const autoplay = config.eshop.theme.selected?.settings?.carousel?.autoplay;
  const autoplaySpeed = config.eshop.theme.selected?.settings?.carousel?.speed;
  const dots = config.eshop.theme.selected?.settings?.carousel?.dots;

  const slickSettings = {
    dots: dots === undefined ? true : config.eshop.theme.selected?.settings?.carousel?.dots,
    fade: transitionType === "fade",
    infinite: true,
    speed: speed || 1000,
    autoplaySpeed: autoplaySpeed || 3000,
    autoplay: autoplay === undefined ? true : config.eshop.theme.selected?.settings?.carousel?.autoplay,
    lazyload: "ondemand",
    slidesToShow: 1,
    arrows: false,
    draggable: true,
    slidesToScroll: 1,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 1080,
        appendDots: null,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          draggable: true
        }
      }
    ]
  };
  const entries = block.data.entries.map(e => ({
    src: findUrlForMediaArray(e.media, e.format),
    to: e.to
  }));

  return (
    <div className="carouselContainer">
      <Slider {...slickSettings}>
        {entries.map((e, i) => (
          <React.Fragment key={i}>
            {e.to && typeof e.to === "string" ? (
              <>
                {e.to.includes("http") ? (
                  <a href={e.to} target="_blank" rel="noopener noreferrer">
                    <img key={e.src} src={e.src} alt={`Carousel entry ${i}`} />
                  </a>
                ) : (
                  <Link to={e.to}>
                    <img key={e.src} src={e.src} alt={`Carousel entry ${i}`} />
                  </Link>
                )}
              </>
            ) : (
              <img key={e.src} src={e.src} alt={`Carousel entry ${i}`} />
            )}
          </React.Fragment>
        ))}
      </Slider>
    </div>
  );
}
